"use client";
import DefaultImage from "@/assets/icons/default-avatar-icon-of-social-media-user-vector.jpg";
import IconMenu from "@/assets/icons/mobile-catalog-icons/icon-menu.svg";
import IconProfile from "@/assets/icons/mobile-catalog-icons/icon-profile.svg";
import IconRadius from "@/assets/icons/mobile-catalog-icons/icon-radius-mobile.svg";
import IconShoppingCart from "@/assets/icons/mobile-catalog-icons/icon-shopping-cart.svg";
import {
  PasswordContent,
  PersonalCabinet,
  ProfilePopupContent,
} from "@/components";
import { Link } from "@/i18n/navigation";
import useMobileMenu from "@/zustand/useMobileMenu";
import useUserStore from "@/zustand/useUser";
import Image from "next/image";
import { usePathname } from '@/i18n/navigation';
import { useState } from "react";
import { useWindowSize } from "react-use";
import { Button, Drawer } from "rsuite";
import DrawerContent from "../drawer-content";
import styles from "./fixed-mobile.module.scss";
import { useTranslations } from "next-intl";
import { useGuestStore } from "@/zustand/guestStore";
import { useDraftOrderQuery, useUserDraftOrdersQuery } from "@/graphql";

const FixedMobileNavbar = () => {
  const [openCatalog, setOpenCatalog] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const user = useUserStore((user: any) => user?.user);
  const isLoggedIn = user?.id;
  const orderId = useGuestStore((state) => state.guestOrderId);
  const { isOpen: openMobileVersion, setOpen: setOpenMobileVersion } =
    useMobileMenu();
  const [openCabinet, setOpenCabinet] = useState(false);
  const t = useTranslations("General");
  const pathname = usePathname();
  const { width } = useWindowSize();

  const { data: draftOrdersData, refetch: refetchDraftOrders } =
    useUserDraftOrdersQuery({
      variables: {
        userId: user?.id,
      },
    });

  const {
    data: guestDraftOrdersData,
    loading: guestDataLaoding,
    refetch: refetchGuestDraftOrdersData,
  } = useDraftOrderQuery({
    variables: {
      id: orderId || "",
    },
    skip: !orderId,
  });

  const handleClose = () => {
    setOpenMobileVersion(false);
    setOpenModal(false);
  };

  const openMobileMenu = () => {
    setOpenMobileVersion(!openMobileVersion);
  };

  const handleOpen = () => {
    setOpenModal(true);
  };

  const handleOpenCatalog = () => {
    handleClose();
    setOpenCatalog(!openCatalog);
  };

  return (
    <>
      <div className={styles.fixedNavbar}>
        <Link
          onClick={handleClose}
          href={"/"}
          className={`${styles.navItem} ${
            pathname === "/" ? styles.activeNavItem : ""
          }`}
        >
          <div className={styles.iconRadius}>
            <IconRadius />
          </div>
          <p>{t("main")}</p>
        </Link>
        <button
          onClick={handleOpenCatalog}
          className={`${styles.navItem} ${
            pathname === "/catalogs" ? styles.activeNavItem : ""
          }`}
        >
          <div className={styles.iconMenu}>
            <IconMenu />
          </div>
          <p>{t("catalog")}</p>
        </button>
        <Link
          onClick={handleClose}
          href={"/cart"}
          className={`${styles.navItem} ${
            pathname === "/cart" ? styles.activeNavItem : ""
          }`}
        >
          <div className={styles.iconShop}>
            <IconShoppingCart />
          </div>
          <p>
            {t("cart")} <span>
            {(isLoggedIn
                ? draftOrdersData?.userDraftOrders?.[0]?.lines?.length
                : guestDraftOrdersData?.draftOrder?.lines?.length) || null}
            </span>
          </p>
        </Link>
        <Button
          onClick={openMobileMenu}
          className={`${styles.navItem} ${
            openMobileVersion ? styles.activeNavItem : ""
          }`}
        >
          {user?.firstName ? (
            <>
              <div className={styles.iconProfile}>
                {" "}
                <Image
                  src={user?.avatar === null ? DefaultImage : user?.avatar?.url}
                  alt="avatar-image"
                  width={24}
                  height={24}
                  style={{
                    objectFit: "cover",
                    borderRadius: "50%",
                    border: "1px solid #000000",
                  }}
                />
              </div>
              <p>
                {user?.firstName} {user?.lastName}
              </p>
            </>
          ) : (
            <>
              <div className={styles.iconProfile}>
                <IconProfile />
              </div>
              <p>{t("profile")}</p>
            </>
          )}
        </Button>
        <div className={styles.mobileVersion}>
          <Drawer
            size={width <= 400 ? "full" : width <= 860 ? "xs" : "full"}
            placement="right"
            open={width > 860 ? false : openMobileVersion}
            onClose={() => setOpenMobileVersion(false)}
            closeButton={false}
          >
            <Drawer.Body style={{ padding: "0" }}>
              <div>
                {openModal ? (
                  <PasswordContent onClose={handleClose} />
                ) : !user ? (
                  <PersonalCabinet
                    handleClose={handleClose}
                    handleOpen={handleOpen}
                  />
                ) : (
                  <ProfilePopupContent
                    handleOpenMobileMenu={openMobileMenu}
                    setOpenCabinet={setOpenCabinet}
                  />
                )}
              </div>
            </Drawer.Body>
          </Drawer>
        </div>
      </div>
      <Drawer
        size={`${
          width <= 767
            ? "calc(100% - 0px"
            : width <= 1241
            ? "calc(100% - 50px"
            : width <= 1510
            ? "calc(100% - 100px"
            : width <= 1750
            ? "calc(100% - 258px"
            : "calc(100% - 490px"
        })`}
        placement="left"
        // backdrop="static"
        onClose={() => setOpenCatalog(false)}
        open={openCatalog}
        closeButton={false}
      >
        <Drawer.Body style={{ padding: "0" }}>
          <div style={{ height: "100%" }}>
            <DrawerContent closeButton={() => setOpenCatalog(false)} />
          </div>
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default FixedMobileNavbar;
